export default "__VITE_ASSET__CkX3e4Ym__"